import React from 'react';
import { Box } from '@mui/material';
import { useAppSelector } from '../../store';
import PreOptimizationCard from './PreOptimizationCard';
import { StrategySelectionView } from './StrategySelectionView';
import { ResultsPanel } from '../index';

const CheckpointMux: React.FC = () => {
    const { pendingCheckpoint, currentNode } = useAppSelector((state) => state.analysis);

    if (!pendingCheckpoint) return null;

    // Gate 1: Strategy Selection (strategist checkpoint)
    // Show Gate 1 if: currently at strategist OR has strategies but NO regions yet
    const isGate1 = currentNode === 'strategist' || (
        pendingCheckpoint.strategy_options &&
        (!pendingCheckpoint.region_contexts || pendingCheckpoint.region_contexts.length === 0)
    );

    if (isGate1) {
        return <ResultsPanel />; // ResultsPanel handles isStrategistGate logic
    }

    // Gate 2: Tactical Review (Constraint Advisor / Pre-Optimization)
    return (
        <Box sx={{ width: '100%' }}>
            <PreOptimizationCard />
        </Box>
    );
};

export default CheckpointMux;
